<template>
  <div :class="{'more-filter':true, 'shrink':shrink}">
    <div class="field row">
      <div :class="['column col-field', shrink ? 'medium-12' : 'medium-8']">
        <div class="column medium-12">
          <label>Date Range</label>
        </div>
        <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']">
          <div class="datepicker-box">
            <datepicker :format="calendarFormat" class="datepicker inline"
              v-model="dateFrom.date" v-on:input="changeDate('from')"
              :disabled-picker="isLoading" :input-class="{'datepicker-empty':hasError.from}"
              :placeholder="$t('transactions.filter.from')"></datepicker>
          </div>
          <div class="row time-selector">
            <div class="column padded medium-4">
              <select v-model="dateFrom.hour" @change="changeTime('from')"
                :disabled="isLoading" :class="{'has-error':hasError.from}">
                <option v-for="n in maxHour" :value="leadingZero(n)" :key="n">{{ leadingZero(n) }}</option>
              </select>
            </div>
            <div class="column padded medium-4">
              <select v-model="dateFrom.minute" @change="changeTime('from')"
                :disabled="isLoading" :class="{'has-error':hasError.from}">
                <option value="00">00</option>
                <option v-for="n in 11" :value="leadingZero(n * 5)" :key="n">{{ leadingZero(n * 5) }}</option>
              </select>
            </div>
            <div class="column medium-4">
              <select v-model="dateFrom.amPm" @change="changeTime('from')"
                :disabled="isLoading" :class="{'has-error':hasError.from}">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>
        <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']">
          <div class="datepicker-box">
            <datepicker :format="calendarFormat" class="datepicker inline"
              v-model="dateTo.date" v-on:input="changeDate('to')"
              :disabled-picker="isLoading" :input-class="{'datepicker-empty':hasError.to}"
              :placeholder="$t('transactions.filter.to')"></datepicker>
          </div>
          <div class="row time-selector">
            <div class="column padded medium-4">
              <select v-model="dateTo.hour" @change="changeTime('to')"
                :disabled="isLoading" :class="{'has-error':hasError.to}">
                <option v-for="n in maxHour" :value="leadingZero(n)" :key="n">{{ leadingZero(n) }}</option>
              </select>
            </div>
            <div class="column padded medium-4">
              <select v-model="dateTo.minute" @change="changeTime('to')"
                :disabled="isLoading" :class="{'has-error':hasError.to}">
                <option value="00">00</option>
                <option v-for="n in 11" :value="leadingZero(n * 5)" :key="n">{{ leadingZero(n * 5) }}</option>
              </select>
            </div>
            <div class="column medium-4">
              <select v-model="dateTo.amPm" @change="changeTime('to')"
                :disabled="isLoading" :class="{'has-error':hasError.to}">
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <div :class="['column padded', shrink ? 'medium-12' : 'medium-2']">
          <div class="clear-dates button cta warning block small" @click="clearDates">Clear Dates</div>
        </div> -->
        <transition name="slide-up">
          <div class="column medium-12">
            <div class="error-msg" v-show="!!hasError.fromToMsg">{{ hasError.fromToMsg }}</div>
          </div>
        </transition>
        <div class="clear"></div>
      </div>

      <div class="column col-field medium-12">
        <div class="column medium-12">
          <label>Service Type</label>
        </div>
        <div class="select-all" @click="selectAllBrands()">
          <div class="select-brand">
            <i :class="['fa-lg', selectedAllServices ? 'fa-check-square fas' : 'far fa-square' ]"></i>
          </div>
          <div class="brand">
            <label>Select All Brands</label>
          </div>
        </div>
        <div v-if="!this.useOldQuatation">
          <div v-for="brand in brands" v-if="serviceList(brand.id).length" class="services" :key="brand.id">
            <div class="select-brand" @click="selectBrand(brand.id)">
              <i :class="['fa-lg', selectedBrand.indexOf(brand.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            </div>
            <div class="brand">
              <div class="head" @click="toggleBrand(brand.id)">
                <i class="fas fa-angle-down" v-if="openBrand.indexOf(brand.id) > -1"></i>
                <i class="fas fa-angle-up" v-else></i>
                {{ brand.name }}
              </div>
              <transition name="height">
                <ul class="body" v-show="openBrand.indexOf(brand.id) > -1">
                  <li v-for="service in serviceList(brand.id)" @click="toggleService(service.id, brand.id)" :key="service.id">
                    <i :class="['fa-lg', selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]"></i>
                    {{service.label}}
                  </li>
                </ul>
              </transition>
            </div>
          </div>
        </div>
        <transition name="slide-up">
          <div class="column medium-12">
            <div class="error-msg" v-show="!!hasError.serviceMsg">
              {{ hasError.serviceMsg }}
            </div>
          </div>
        </transition>
      </div>

      <div class="column col-field medium-12">
        <div>
          <label>Reservation Status</label>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('upcoming')">
            <i :class="['fa-lg', status.upcoming ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>Upcoming</span>
          </div>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('ready')">
            <i :class="['fa-lg', status.ready ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>Ready to go</span>
          </div>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('require-dispatch')">
            <i :class="['fa-lg', status['require-dispatch'] ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>Requires Dispatch</span>
          </div>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('dispatched')">
            <i :class="['fa-lg', status.dispatched ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>Dispatched</span>
          </div>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('onboard')">
            <i :class="['fa-lg', status.onboard ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>On Board</span>
          </div>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('completed')">
            <i :class="['fa-lg', status.completed ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>Completed</span>
          </div>
        </div>
        <div :class="['column end service', shrink ? 'medium-12' : 'medium-3']">
          <div @click="selectStatus('cancelled')">
            <i :class="['fa-lg', status.cancelled ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            <span>Cancelled</span>
          </div>
        </div>
        <transition name="slide-up">
          <div class="column medium-12">
            <div class="error-msg" v-show="!!hasError.statusMsg">{{ hasError.statusMsg }}</div>
          </div>
        </transition>
        </div>
      </div>

      <div class="row">
        <div :class="['column col-btn', shrink ? 'medium-12' : 'medium-8 medium-offset-2']">
          <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']" v-if="!shrink">
            <div class="button cta warning block small" @click="close">close</div>
          </div>
          <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']">
            <div class="button cta success block small" @click="applyFilter">Apply Filter</div>
          </div>
          <div :class="['column padded', shrink ? 'medium-12' : 'medium-6']" v-if="shrink">
            <div class="button cta warning block small" @click="close">close</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'
import services from '@/modules/api/services'
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'

export default {
  name: 'dispatch-more-filter',
  props: [ 'shrink' ],
  components: { datepicker },
  data () {
    return {
      hasError: {
        from: false,
        to: false,
        fromToMsg: '',
        serviceMsg: '',
        statusMsg: ''
      },
      firstBrand: false,
      openBrand: [],
      selectedBrand: [],
      selectedAllServices: false,
      selectedService: [],
      maxHour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    }
  },
  computed: {
    date () { return this.$store.state.reservation.date },
    dateFrom () {
      let date = moment(this.date.from, 'MM/DD/YYYY hh:mmA')
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      }
    },
    dateTo () {
      let date = moment(this.date.to, 'MM/DD/YYYY hh:mmA')
      return {
        date: date.format('MM/DD/YYYY'),
        hour: date.format('hh'),
        minute: date.format('mm'),
        amPm: date.format('A')
      }
    },
    service () { return this.$store.state.reservation.service },
    status () { return this.$store.state.reservation.status },
    isLoading () { return this.$store.state.transactions.loading },
    serviceData () { return this.$store.state.settings.serviceData },
    useOldQuatation () { return CONFIG.useOldQuatation },
    brands () { return this.$store.state.brands.list }
  },
  methods: {
    calendarFormat (date) { return moment(date, 'MM/DD/YYYY').format('MM/DD/YYYY') },
    changeDate (type) {
      // this.$store.commit('transactions/setDate', 'custom')

      this.hasError[type] = false

      let format = 'MM/DD/YYYY hh:mmA'
      let selectedTime = ''
      let target = type === 'from' ? this.dateFrom : this.dateTo

      selectedTime = moment(target.date)
      selectedTime = moment(`${selectedTime.format('MM/DD/YYYY')} ${target.hour}:${target.minute}${target.amPm}`, 'MM/DD/YYYY hh:mmA')
      this.$store.commit('reservation/setDateFilter', {
        fromTo: type,
        value: selectedTime.format(format)
      })
    },
    changeTime (type) {
      let target = type === 'from' ? this.dateFrom : this.dateTo
      this.$store.commit('reservation/setDateFilter', {
        fromTo: type,
        value: `${target.date} ${target.hour}:${target.minute}${target.amPm}`
      })
    },
    clearDates () {
      this.hasError.from = false
      this.hasError.to = false
      this.hasError.fromToMsg = ''

      this.$store.commit('reservation/setDateFilter', { fromTo: 'from', value: '' })
      this.$store.commit('reservation/setDateFilter', { fromTo: 'to', value: '' })
    },
    selectService (service) {
      this.hasError.serviceMsg = ''
      this.$store.commit('reservation/setService', {
        service: service,
        value: !this.service[service]
      })
    },
    selectStatus (status) {
      this.$store.commit('reservation/setStatus', {
        status: status,
        value: !this.status[status]
      })
    },
    applyFilter () {
      this.hasError.from = false
      this.hasError.to = false
      this.hasError.fromToMsg = ''

      if (
        (this.date.from === '' && this.date.to !== '') ||
        (this.date.from !== '' && this.date.to === '')
      ) {
        if (this.date.from === '') { this.hasError.from = true }
        if (this.date.to === '') { this.hasError.to = true }
        this.hasError.fromToMsg = this.$t('dispatch.filter.emptyDate')
        return
      }
      if (moment(this.date.from, 'MM/DD/YYYY').format('x') > moment(this.date.to, 'MM/DD/YYYY').format('x')) {
        this.hasError.from = true
        this.hasError.to = true
        this.hasError.fromToMsg = this.$t('dispatch.filter.invalidDateRange')
        return
      }

      let hasSelectedService = false
      this.$store.commit('dispatch/setFilterService', [])
      if (!this.useOldQuatation) {
        if (this.selectedService.length) {
          hasSelectedService = true
          this.$store.commit('dispatch/setFilterService', this.selectedService)
        }
      } else {
        for (let service in this.service) {
          if (this.service[service]) {
            hasSelectedService = true
          }
        }
      }

      if (!hasSelectedService) {
        this.hasError.serviceMsg = 'Please select at least one service type.' //this.$t('dispatch.filter.noServiceSelected')
        return
      }

      let hasSelectedStatus = false
      for (let status in this.status) {
        if (this.status[status]) {
          hasSelectedStatus = true
        }
      }

      if (!hasSelectedStatus) {
        this.hasError.statusMsg = this.$t('dispatch.filter.noServiceStatus')
        return
      }

      this.close()
      this.$store.commit('dispatch/setRsvpCurrentPage', 1)
      ApiDispatchReservation.getReservations(this)
      ApiDispatchReservation.getLastSync(this)
    },
    close () { this.$emit('close') },
    serviceLabel ( code ) { return services.getServiceName(code) },
    serviceList (brandId) {
      let serviceList = this.$store.state.services.list.filter(x => x.brandId === brandId)
      if (!this.firstBrand && serviceList.length) {
        // this.openBrand.push(brandId)
        // this.firstBrand = true
      }
      return serviceList
    },
    toggleBrand (brandId) {
      if (this.openBrand.indexOf(brandId) > -1) {
        let index = this.openBrand.indexOf(brandId)
        this.openBrand.splice(index, 1)
      } else {
        if(this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId)
        }
      }
    },
    toggleService (serviceId, brandId) {
      if (this.selectedService.indexOf(serviceId) > -1) {
        let index = this.selectedService.indexOf(serviceId)
        this.selectedService.splice(index, 1)
      } else {
        this.selectedService.push(serviceId)
      }

      let services = this.serviceList(brandId)
      let checkServices = services.map(brand => brand.id)
      if (checkServices.every(id => this.selectedService.includes(id))) {
        if(this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId)
        }
      } else {
        if(this.selectedBrand.indexOf(brandId) > -1) {
          let index = this.selectedBrand.indexOf(brandId)
          this.selectedBrand.splice(index, 1)
        }
      }
    },
    selectAllBrands () {
      let brands = this.brands
      if(!this.selectedAllServices){
        brands.forEach(brand => {
          if(this.selectedBrand.indexOf(brand.id) === -1) {
            this.selectedBrand.push(brand.id)
          }
          if(this.openBrand.indexOf(brand.id) === -1) {
            this.openBrand.push(brand.id)
          }
          let services = this.serviceList(brand.id)
          services.forEach(service => {
            if(this.selectedService.indexOf(service.id) === -1) {
              this.selectedService.push(service.id)
            }
          })
        })
      } else {
        this.selectedBrand = []
        this.selectedService = []
      }
      this.selectedAllServices = !this.selectedAllServices
    },
    selectBrand (brandId) {
      let services = this.serviceList(brandId)
      if (this.selectedBrand.indexOf(brandId) > -1) {
        let index = this.selectedBrand.indexOf(brandId)
        this.selectedBrand.splice(index, 1)
        services.forEach(service => {
          let index = this.selectedService.indexOf(service.id)
          this.selectedService.splice(index, 1)
        })
        this.selectedAllServices = false
      } else {
        if(this.selectedBrand.indexOf(brandId) === -1) {
          this.selectedBrand.push(brandId)
        }
        services.forEach(service => {
          if(this.selectedService.indexOf(service.id) === -1) {
            this.selectedService.push(service.id)
          }
        })
        if(this.openBrand.indexOf(brandId) === -1) {
          this.openBrand.push(brandId)
        }
      }

      if (this.brands.every(brand => this.selectedBrand.includes(brand.id))) {
        this.selectedAllServices = true
      }
    },
    leadingZero (n) { return parseInt(n) < 10 ? '0' + n : n },
  },
  mounted () {
    let self = this
    if (!self.$store.state.settings.serviceData.Shared.label) {
      self.$store.commit('brands/setLoading', true)
      self.$sdk.get('/brand', {}, res => {
        self.$store.commit('brands/setLoading', false)
        if (!this.useOldQuatation && res.length) {
          self.$store.commit('brands/setList', res)
        }
      })
    }

    if (!self.$store.state.services.list.length) {
      self.$store.commit('services/setServiceLoading', true)
      services.getAllService(self, r => {
        self.$store.commit('services/setServiceLoading', false)
        self.$store.commit('dispatch/setReloadDrivers', true)
      })
    }

    if (!self.$store.state.reservation.date.from) {
      self.$store.commit('reservation/setDateFilter', {
        fromTo: 'from',
        value: moment('00:00AM', 'hh:mmA').format(`MM/DD/YYYY hh:mmA`)
      })
      self.$store.commit('reservation/setDateFilter', {
        fromTo: 'to',
        value: moment('00:00AM', 'hh:mmA').add(1, 'days').format(`MM/DD/YYYY hh:mmA`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.clear{ clear:both; }
.more-filter{
  position: absolute;
  top: 51px;
  left: 0;
  width: 100%;
  height: calc(100vh - 50px);
  background: #eaf1f3;
  padding: 20px 15px;
  border-bottom: 1px solid #aaa;
  border-right: 1px solid #aaa;
  box-shadow: -3px 1px 3px rgba(0,0,0, .2);
  overflow: auto;

  .col-field, .col-btn{ padding: 0 10px; }
  .col-field{ margin-bottom: 10px; }
  .col-btn{ margin-top: 10px; }

  &.shrink{
    height: calc(100vh - 50px);
    .datepicker-box{ margin-bottom: 5px; }
    .button{ margin-bottom: 5px;}
  }
}

.row{
  max-width: 100%;
  margin-bottom: 20px;
}
.row:last-child{ margin-bottom: 10px; }
.column.padded{
  padding-right: 10px;
}

label{
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
  display: block;
  color: #555;
}
.datepicker-box{
  display: inline-block;
  width: 100%;
}
.time-selector{
  padding: 5px 0;

  select{
    border-color: #ccc;
    padding: 3px;
  }
}
.shrink{
  .time-selector{
    padding: 0 0 5px;
  }
}

.clear-dates{ margin-top: 3px; }

.error-msg{
  width: 100%;
  padding: 2px 5px;
  font-size: 12px;
  color: #f33a27;
  transform-origin: top center;
}

.service{
  font-size: 14px;
  margin-bottom: 3px;

  *{ cursor: pointer; }
  i{
    margin-right: 5px;
    color: #5ec1ac;

    &.far{ color: #999; }
  }
}

.select-brand {
  float: left;
  width: 3%;
  color: #999;
  cursor: pointer;
  i{
    padding: 6px 0;
    margin-right: 5px;
    &.fa-check-square{ color: #5ec1ac; }
  }
}

.brand {
  float: left;
  width: 97%;
}

.select-all {
  .brand {
    width: auto;
  }
  .brand label {
    cursor: pointer;
    padding: 4px 0;
    display: inline-block;
  }
}

.services{
  clear: both;

  .head{
    padding: 5px;
    background: #5ec1ac;
    color: #fff;
    border: 1px solid #3d8374;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;

    i{ margin-right: 5px; }
  }
  .body{
    list-style: none;
    margin: 0;
    padding: 5px 0;
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    column-gap: 5px;
    background: #fff;
    border: 1px solid #3d8374;
    max-height: 999px;

    li{
      padding: 3px 10px;
      font-size: 13px;
      cursor: pointer;

      &:hover{ background: #f3f3f3; }
      i{
        vertical-align: middle;
        margin-right: 5px;
        &.fa-check-square{ color: #5ec1ac; }
      }
    }
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
.height-enter-active, .height-leave-active { transition: all .2s ease; }
.height-enter, .height-leave-to {
  max-height: 0;
  opacity: 0;
}
@media only screen and (max-width: 430px) {
  .header .more-filter {
    padding-bottom: 100px;
  }
  label {
    margin-bottom: 4px;
  }
  .column.padded {
    padding: 0;
  }
  .medium-6 {
    width: 50%;
    padding: 0 2px !important;
  }
  .medium-4 {
    width: 33.3%;
  }
  .brand {
    width: 90%;
    margin-left: 5%;
    margin-bottom: 5px;
  }
  .services .body {
    column-count: 2;
    li {
      padding: 3px 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/MoreFilter.vue